import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
  }

  // Create Modal Methods
  openCreate(event) {
    event?.preventDefault()
    const modal = document.getElementById('create_rotation_modal')
    if (modal) {
      modal.showModal()
    }
  }

  closeCreate() {
    const modal = document.getElementById('create_rotation_modal')
    if (modal) {
      modal.close()
    }
  }

  closeCreateOnBackdrop(event) {
    const modal = document.getElementById('create_rotation_modal')
    if (event.target === modal) {
      this.closeCreate()
    }
  }

  // Edit Modal Methods
  openEdit(event) {
    event?.preventDefault()
    const modal = document.getElementById('edit_rotation_modal')
    if (modal) {
      modal.showModal()
    }
  }

  openEditFromCard(event) {
    return this.openLazyModal(event, 'edit_rotation_modal')
  }

  openSummaryFromCard(event) {
    return this.openLazyModal(event, 'rotation_summary_modal')
  }

  // The index fetches each modal on demand (data-modal-url) and keeps it in the
  // DOM afterwards. Screens that still render theirs upfront just find them there.
  async openLazyModal(event, idPrefix) {
    event?.preventDefault()
    event?.stopPropagation()

    const button = event.currentTarget
    const { rotationId, modalUrl } = button.dataset
    const modalId = `${idPrefix}_${rotationId}`

    const existing = document.getElementById(modalId)
    if (existing) {
      existing.showModal()
      return
    }

    if (!modalUrl) return

    button.classList.add('opacity-50', 'pointer-events-none')

    try {
      const response = await fetch(modalUrl, { headers: { Accept: 'text/html' } })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      const container = document.getElementById('lazy_rotation_modals')
      if (!container) return

      container.insertAdjacentHTML('beforeend', await response.text())
      document.getElementById(modalId)?.showModal()
    } catch (error) {
      console.error('Error loading rotation modal:', error)
      window.showNotification?.('Erro ao abrir a roleta.', 'error')
    } finally {
      button.classList.remove('opacity-50', 'pointer-events-none')
    }
  }

  closeSummary(event) {
    event?.preventDefault()
    event?.currentTarget?.closest('dialog')?.close()
  }

  closeEdit() {
    // Close any open edit modal
    document.querySelectorAll('[id^="edit_rotation_modal"]').forEach(modal => {
      if (modal.open) {
        modal.close()
      }
    })
  }

  closeEditOnBackdrop(event) {
    if (event.target.tagName === 'DIALOG') {
      event.target.close()
    }
  }

  // Delete Modal Methods
  openDelete(event) {
    event?.preventDefault()
    const modal = document.getElementById('delete_rotation_modal')
    if (modal) {
      modal.showModal()
    }
  }

  closeDelete() {
    const modal = document.getElementById('delete_rotation_modal')
    if (modal) {
      modal.close()
    }
  }

  closeDeleteOnBackdrop(event) {
    const modal = document.getElementById('delete_rotation_modal')
    if (event.target === modal) {
      this.closeDelete()
    }
  }

  // Handle escape key to close modals
  handleEscape(event) {
    if (event.key === 'Escape') {
      this.closeCreate()
      this.closeEdit()
      this.closeDelete()
    }
  }

  // Handle mutual exclusivity between source_role and source_group
  handleSourceChange(event) {
    const sourceType = event.currentTarget.dataset.sourceType
    const selectedValue = event.currentTarget.value
    const form = event.currentTarget.closest('form')

    if (!form || !selectedValue) return

    // If a role is selected, clear the group
    if (sourceType === 'role') {
      const groupSelect = form.querySelector('select[name*="source_group_id"]')
      if (groupSelect) groupSelect.value = ''
    }

    // If a group is selected, clear the role
    if (sourceType === 'group') {
      const roleSelect = form.querySelector('select[name*="source_role_id"]')
      if (roleSelect) roleSelect.value = ''
    }
  }
}
